export default __webpack_public_path__ + "static/media/18_Extra_Chonky.5f3683a0.png";